import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipTrigger } from "@libs/zapi-ui/shadcn";
import { SidebarCollapseIcon } from "@libs/zapi-ui/assets";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TSidebarCollapseFooterProps = {
  collapsed: boolean;
  onToggle: () => void;
  testId?: string;
};

export function SidebarCollapseFooter({ collapsed, onToggle, testId }: TSidebarCollapseFooterProps) {
  const { t } = useTranslation("projectHome");
  return (
    <div className="h-16 shrink-0 border-t border-innoveraZinc-100 px-2 flex flex-col items-stretch justify-center bg-white">
      <Tooltip open={collapsed ? undefined : false}>
        <TooltipTrigger asChild>
          <button
            type="button"
            data-testid={testId}
            onClick={onToggle}
            aria-label={collapsed ? t("sidebar.expandSidebar") : t("sidebar.collapseSidebar")}
            className={cn(
              "flex items-center gap-1 h-8 w-full p-2 rounded-lg text-left transition-colors outline-none focus:outline-none focus-visible:outline-none",
              "text-[14px] leading-4 font-medium text-innoveraZinc-500 hover:bg-innoveraZinc-50"
            )}
          >
            <span className="shrink-0 inline-flex">
              <SidebarCollapseIcon className={cn("transition-transform duration-200", collapsed && "rotate-180")} />
            </span>
            <span
              className={cn(
                "flex-1 min-w-0 truncate transition-[opacity] duration-200",
                collapsed && "opacity-0 max-w-0 flex-none"
              )}
            >
              {t("sidebar.collapse")}
            </span>
          </button>
        </TooltipTrigger>
        <TooltipContent side="right">{collapsed ? t("sidebar.expand") : t("sidebar.collapse")}</TooltipContent>
      </Tooltip>
    </div>
  );
}
